import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';

import { H3, H4, Button } from '@blueprintjs/core';
import MaterialTable from 'material-table';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';
import { openPagePopup } from '../../../utils'

class MetaByCorpus extends React.PureComponent {

  state = {

  }

  render() {
    const { data, name, t } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
        
    let tableData = [];
    let cols={};
    let types={}
    for (var docKey in data.docs) {
      const row = {...data.docs[docKey], id:docKey };
      tableData.push(row);
      for (var field in data.docs[docKey]) {
        cols[field]=1;
        if (! types[field]) {
          types[field]={}
        }
        types[field][data.docs[docKey][field]]=1;
      }
      //console.log(docKey);
    }
    // counting types for each field
    for (field in types) {
      types[field]=(Object.keys(types[field])).length;
    }

    let columns=[{ title: 'Id', field: 'id' }, { title: 'Tokens', field: 'nbToks'}];
    
    // the ability to access the corpus in open way (for page displaying) is set at the level of corpusId
    if (data["isOpen"]) {
      columns.unshift({ 
        title: t('reading'), 
        render: rowData => <Button onClick={ 
          (e)=>{ 
            e.stopPropagation();
            openPagePopup(this.props.language,rowData['collection'],rowData['fileId'],rowData['firstSentId'],this.props.aligned_language);
          }
        }>{t('reading')}</Button>,
      });
    }

    // sort the field
    let fields=Object.keys(cols).sort();
    for (var i=0;i<fields.length;i++) {
      const field=fields[i];
      if (field !== 'nbToks') {
        columns.push({title: field, field: field } );
      }
    }
    // sort data 
    tableData.sort((a, b) => {
      if (a.id < b.id ) return -1;
      if (a.id > b.id ) return 1;
      return 0
    });

    const metaTable = (
      <MaterialTable
        columns={columns}
        data={tableData}
        title={t('metadataPerDocument')}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`metadata`,
          exportAllData: true,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 25, 50, 100, tableData.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );
    
    
   /*  const panels = [];
    for (var i=0;i<docKeys.length;i++) {
      const docKey=docKeys[i];
      const docMeta=data.docs[docKey];
      const metaDataEls = Object.keys(docMeta).sort().map(key => (
        <li key={key}>{key}: {docMeta[key]}</li>
      ));
      const panel= 
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <H3>{docKey}</H3>
            </AccordionSummary>
            <AccordionDetails>
              <section>
                <H3>{t('docMeta')}</H3>
                <ul>
                  {metaDataEls}
                </ul>
              </section>
            </AccordionDetails>
          </Accordion>;
      panels.push(panel);
    } */
    
    return(
      <>
        <Paper className="margin-bottom-1-rem padding-1-rem">

          <H3>{name}</H3>
          <ul>
            <li>{t('tokenNumberColon')} { Intl.NumberFormat(langFormat).format(data.nbToks)}</li>
            <li>{t('sentNumberColon')} { Intl.NumberFormat(langFormat).format(data.nbSents)}</li>
            <li>{t('docNumberColon')} { Intl.NumberFormat(langFormat).format(data.nbDocs)}</li>
          </ul>
          <H4>Types</H4>
          <ul>
            {fields.filter( field => field !== 'nbToks' && field !== 'firstSentId' && field !== 'wordsnumber'  && types[field] !==  data.nbDocs ).map( field =>  <li>{field} : { Intl.NumberFormat(langFormat).format(types[field])}</li>)}
          </ul>


          {metaTable}
         
        </Paper>
      </>
    );
  }

}

MetaByCorpus.propTypes = {
  name: PropTypes.string,
  data: PropTypes.object,
  language : PropTypes.string,
  aligned_language : PropTypes.string,
};

export default withTranslation()(MetaByCorpus);
